module.exports = __webpack_public_path__ + "static/media/mobile development.15117cc3.svg";